import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import './styles/TagTimePicker.css';

const TagTimePicker = (props) => {
  const [value, setValue] = useState(props.value ? dayjs(`1970-01-01T${props.value}`) : null);
  const tipText = props.prompt || '';
  const validationCase = props.validationCase || 'none';
  const isTagChecked = props.isTagChecked || false;
  const isAlwaysOn = props.isAlwaysOn || false;

  useEffect(() => {
    setValue(props.value ? dayjs(`1970-01-01T${props.value}`) : null);
  }, [props.value]);

  const isEmpty = !value || (typeof value.isValid === 'function' && !value.isValid());
  const error =
    (validationCase === 'case_4' && props.required && isAlwaysOn && isEmpty) ||
    (validationCase === 'case_2' && props.required && isTagChecked && isEmpty);
  const helperText = error
    ? (validationCase === 'case_4' ? 'This field is required' : 'This field is required if active')
    : '';

  const handleChange = (newValue) => {
    setValue(newValue);
    // Send as local wall-clock HH:mm (24-hour) string, matching the YYYY-MM-DD HH:mm
    // format used by other date/time pickers.
    const formatted = newValue
      ? `${String(newValue.hour()).padStart(2, '0')}:${String(newValue.minute()).padStart(2, '0')}`
      : null;
    props.onChange({
      name: props.param,
      value: formatted,
    });
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12}>
        <Tooltip title={tipText} placement="top" arrow>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              fullWidth
              size="small"
              label={props.label}
              value={value}
              onChange={handleChange}
              ampm={false}
              format="HH:mm"
              disabled={props.disabled}
              className="datetime-picker"
              slotProps={{ textField: { placeholder: '', error, helperText } }}
            />
          </LocalizationProvider>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default TagTimePicker;
